import React, { FC } from 'react';
import { ShareHero } from '../ShareHero';
import { CallToAction } from '../CallToAction';

export const MarketplaceAdvertising: FC = () => {
    return (
        <>
            <CallToAction />
            <ShareHero />
        </>
    );
};
